<script>
import { mapMutations } from 'vuex';
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Answer from './Answer';

export default {
  name: 'ModuleExamsEditionQuestion',
  components: {
    CKEditor: CKEditor.component,
    Answer,
  },
  props: {
    item: Object,
    order: Number,
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
    };
  },
  computed: {
    questionId() {
      return `question-${this.order + 1}`;
    },
    title: {
      get() {
        return this.item.title || '';
      },
      set(value) {
        const { item } = this;
        item.title = value;
        this.updateQuestion(this.order, item);
      },
    },
    description: {
      get() {
        return this.item.description || '';
      },
      set(value) {
        const { item } = this;
        item.description = value;
        this.updateQuestion(this.order, item);
      },
    },
    numberOfAnswers: {
      get() {
        return this.item.numberOfAnswers;
      },
      set(value) {
        const { item } = this;
        item.numberOfAnswers = parseInt(value);
        this.updateQuestion(this.order, item);
      },
    },
  },
  methods: {
    ...mapMutations('exam/item', [
      'updateQuestion',
      'removeQuestion',
      'addAnswer',
    ]),
    remove() {
      this.removeQuestion(this.order);
    },
  },
};
</script>
<template>
    <div class="box mt-3">
        <h1 class="h3 mb-3">Question {{ order + 1 }}</h1>
        <div class="form-group mt-3">
            <label :for="`${questionId}-title`" class="d-block">Title</label>
            <input :id="`${questionId}-title`" class="form-control rounded-0" v-model="title" />
        </div>
        <div class="form-group mt-3">
            <label :for="`${questionId}-description`" class="d-block">Description</label>
            <CKEditor :id="`${questionId}-description`" :editor="editor" v-model="description" :config="editorConfig" />
        </div>
        <div class="form-group mt-3">
            <label :for="`${questionId}-number-of-answers`" class="d-block">Number Of Answers</label>
            <input :id="`${questionId}-number-of-answers`" type="number" min="1" class="form-control rounded-0" v-model="numberOfAnswers" />
        </div>

        <div class="m-4">
            <h1 class="h3 mb-3">Answers</h1>
            <answer v-for="(answer, index) in item.answers" :key="index" :index="index" :item="answer" :questionIndex="order" />
        </div>

        <div class="d-flex justify-content-between">
            <button class="btn btn-danger" @click="addAnswer(order)">Add Answer</button>
            <button class="btn btn-danger" @click="remove">Remove</button>
        </div>
    </div>
</template>
